import * as React from "react";
import { forwardRef } from "react";
const SvgResponseFieldBillingRelevantIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8 0a8 8 0 1 0 0 16 8 8 0 0 0 8-8 8 8 0 0 0-8-8m2.027 7a1 1 0 1 1 0 2H7.178a3.03 3.03 0 0 0 2.849 2 1 1 0 1 1 0 2 5.034 5.034 0 0 1-4.933-4h-1.12a1 1 0 1 1 0-2h1.12a5.034 5.034 0 0 1 4.933-4 1 1 0 1 1 0 2 3.03 3.03 0 0 0-2.849 2h2.849Z", fill: "currentColor", fillRule: "evenodd", "data-name": "Pfad 1455" }));
const ForwardRef = forwardRef(SvgResponseFieldBillingRelevantIcon);
export { ForwardRef as ReactComponent };
